(() => {
  const drawer = document.querySelector('[data-cart-drawer]');
  const overlay = document.querySelector('.cart-overlay');
  const contents = document.querySelector('[data-cart-contents]');
  const money = cents => new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(cents / 100);

  function openCart() {
    if (!drawer || !overlay) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.hidden = false;
    document.body.classList.add('cart-open');
    refreshCart();
  }
  function closeCart() {
    drawer?.classList.remove('is-open');
    drawer?.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.hidden = true;
    document.body.classList.remove('cart-open');
  }
  async function refreshCart() {
    const cart = await fetch('/cart.js').then(response => response.json());
    document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
    if (!contents) return;
    if (!cart.items.length) {
      contents.innerHTML = '<p class="empty">Your cart is empty.</p><a class="text-link" href="/collections/all">Explore the collection</a>';
      return;
    }
    contents.innerHTML = `<div class="cart-items">${cart.items.map(item => `<div><span>${item.product_title}<small>${item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : 'Made to order'}</small></span><strong>${money(item.final_line_price)}</strong><button type="button" data-remove-key="${item.key}">Remove</button></div>`).join('')}</div><div class="cart-total"><span>SUBTOTAL</span><strong>${money(cart.total_price)} AUD</strong></div><a class="checkout" href="/checkout">CHECKOUT →</a><small>Shipping calculated at checkout</small>`;
  }
  document.addEventListener('click', async event => {
    if (event.target.closest('[data-cart-open]')) openCart();
    if (event.target.closest('[data-cart-close]')) closeCart();
    const remove = event.target.closest('[data-remove-key]');
    if (remove) {
      await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: remove.dataset.removeKey, quantity: 0 }) });
      refreshCart();
    }
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-product-form]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    button.disabled = true;
    try {
      const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!response.ok) throw new Error('Unable to add this item');
      openCart();
    } catch (error) {
      alert(error.message);
    } finally { button.disabled = false; }
  });

  document.querySelectorAll('[data-product-section]').forEach(section => {
    const variants = JSON.parse(section.querySelector('[data-product-json]')?.textContent || '[]');
    const optionInputs = [...section.querySelectorAll('[data-option-index]')];
    const variantSelect = section.querySelector('[data-variant-select]');
    const mainImage = section.querySelector('.product-main-image');
    const thumbnails = [...section.querySelectorAll('[data-gallery-thumb]')];

    thumbnails.forEach(thumbnail => thumbnail.addEventListener('click', () => {
      if (!mainImage) return;
      mainImage.src = thumbnail.dataset.imageSrc;
      mainImage.alt = thumbnail.dataset.imageAlt || '';
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      thumbnails.forEach(item => item.setAttribute('aria-current', String(item === thumbnail)));
    }));

    optionInputs.forEach(input => input.addEventListener('change', () => {
      const choices = optionInputs.map(element => element.value);
      const variant = variants.find(item => item.options.every((option, index) => option === choices[index]));
      if (!variant) return;
      variantSelect.value = variant.id;
      section.querySelector('[data-product-price]').textContent = `${money(variant.price)} AUD`;
      const submit = section.querySelector('[type="submit"]');
      submit.disabled = !variant.available;
      submit.textContent = variant.available ? 'ADD TO CART' : 'SOLD OUT';
    }));
  });
})();
